export default __webpack_public_path__ + "static/media/pp-rebate-m.b02ef98f.webp";